/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';

const Select = styled.select`
  border: 1px solid #ccc;
  width: 100%;
  font-size: 0.86em;
  font-family: inherit;
  padding-left: 5px;
  background-color: white;
  padding: 5px;
  // border-radius: 4px;
  height: 32px;
    &:disabled{
    background-color: lightgray;
  }
`;

export default Select;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/Select/index.js